import * as React from "react";
const SvgFiRrCheckInCalendar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-check-in-calendar_svg__a)">
      <path
        fill="#062147"
        d="M19 2h-1V1a1 1 0 0 0-2 0v1H8V1a1 1 0 0 0-2 0v1H5C2.243 2 0 4.243 0 7v5a1 1 0 0 0 2 0v-2h20v9c0 1.654-1.346 3-3 3H5a3 3 0 0 1-2.906-2.25 1 1 0 0 0-1.937.499 5 5 0 0 0 4.842 3.75h14c2.757 0 5-2.243 5-5V7c0-2.757-2.242-5-4.999-5M2 8V7c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3v1zm-1 7h6.948l-1.571-1.571a.999.999 0 1 1 1.414-1.414l2.659 2.659c.731.731.731 1.92 0 2.651l-2.659 2.659a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l1.571-1.571H1a1 1 0 0 1 0-2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-check-in-calendar_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCheckInCalendar;
